export const MEDIA__PHONES = 768;
export const MEDIA__TABLETS = 992;
export const MEDIA__DESKTOPS = 1200;

export const breakpoints = {
  phone: `(max-width: ${MEDIA__PHONES - 1}px)`,
  tablet: `(min-width: ${MEDIA__PHONES}px) and (max-width: ${MEDIA__TABLETS - 1}px)`,
  medium: `(min-width: ${MEDIA__TABLETS}px) and (max-width: ${MEDIA__DESKTOPS - 1}px)`,
  large: `(min-width: ${MEDIA__DESKTOPS}px)`,
};
